import { render } from "./TwitterModal.vue?vue&type=template&id=7800c48e"
import script from "./TwitterModal.vue?vue&type=script&lang=js"
export * from "./TwitterModal.vue?vue&type=script&lang=js"

import "./TwitterModal.vue?vue&type=style&index=0&id=7800c48e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__